import { Section } from './TextSection';
import { SectionBase } from './SectionBase';

export class ArrowSection extends SectionBase {
    constructor(options: Section) {
        super(options);
    }

    clone() {
        return new ArrowSection(this.toJSON());
    }

    render(): HTMLDivElement {
        const wrapper = document.createElement('div');
        wrapper.classList.add('wrapper');
        
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('width', '100%');
        svg.setAttribute('height', '100%');
        svg.setAttribute('viewBox', `0 0 ${this.width} ${this.height}`); // Add viewBox for consistent scaling
        //svg.setAttribute('preserveAspectRatio', 'none');
        
        const arrow = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        arrow.classList.add('section', 'arrow-section');
        
        const direction = this.propInfo?.find(p => p.name === 'direction')?.value || 'right';
        const strokeColor = this.propInfo?.find(p => p.name === 'strokeColor')?.value || '#000000';
        const strokeWidth = this.propInfo?.find(p => p.name === 'strokeWidth')?.value || '2';
        const fillType = this.propInfo?.find(p => p.name === 'fillType')?.value || '0,0';

        // Set path data based on direction
        const pathData = this.getArrowPath(svg, direction, Number(strokeWidth.replace('px','')));
        arrow.setAttribute('style', 'vector-effect: non-scaling-stroke;');
        arrow.setAttribute('d', pathData);
        arrow.setAttribute('stroke', strokeColor);
        arrow.setAttribute('stroke-width', strokeWidth);
        arrow.setAttribute('stroke-dasharray', fillType);
        arrow.setAttribute('fill', 'none');

        svg.appendChild(arrow);
        
        wrapper.appendChild(svg);

        return wrapper;
    }

    private getArrowPath(svg:SVGSVGElement, direction: string, strokeWidth:number): string {
        // Define paths using absolute coordinates based on viewBox (0-100)
        const arrowHeadHeight:number = (5 + strokeWidth);
        const arrowHeadLength:number = (10 + strokeWidth);
        const gap:number = strokeWidth/2;
        const arrowPaths = {
            right: `M 0,${this.height/2} L ${this.width - gap},${this.height/2} M ${this.width - arrowHeadLength - gap}, ${(this.height/2) - arrowHeadHeight} L ${this.width - gap},${this.height/2} L ${this.width - arrowHeadLength - gap}, ${(this.height/2) + arrowHeadHeight}`,
            left: `M ${this.width-gap},${this.height/2} L 0,${this.height/2} M ${arrowHeadLength},${(this.height/2) - arrowHeadHeight} L 0,${this.height/2} L ${arrowHeadLength},${(this.height/2) + arrowHeadHeight}`,
            up: `M ${this.width/2},${this.height} L ${this.width/2},0 M ${(this.width/2) - arrowHeadHeight},${arrowHeadLength} L ${this.width/2},0 L ${(this.width/2) + arrowHeadHeight},${arrowHeadLength}`,
            down: `M ${this.width/2},0 L ${this.width/2},${this.height} M ${(this.width/2) - arrowHeadHeight},${this.height - arrowHeadLength} L ${this.width/2},${this.height} L ${(this.width/2) + arrowHeadHeight},${this.height - arrowHeadLength}`
        };
        const bbox = svg.getBoundingClientRect();
        const widthRatio = bbox.width / 100;
        const arrowLength = 100; // Full viewBox width
        const headSize = 10 / widthRatio; // Maintain constant visual size
        return arrowPaths[direction as keyof typeof arrowPaths] || arrowPaths.right;
    }
}
